<template>
  <main>
    <section v-show="visible">
      <div id="headerSection" class="whiteBackground text-center p-3">
        <b-row class="mt-2 mb-4">
          <b-col cols="12">
            <h4 v-if="!hasOversightPermission" class="myStudiesHeader">
              My Study-Sites
            </h4>
            <h4 v-else class="myStudiesHeader ">
              <span style="color: #00004E;">My Study-Sites</span>
              <span style="cursor: pointer" @click="switchMode">| All Study-Sites</span>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="col-lg-12 col-lg-offset-12">
            <b-input
              id="filterEverything"
              v-model="filters.everywhere"
              class="filterInput"
              placeholder="Add a term to filter Study Sites"
              type="search"
              width="400px"
            ></b-input>
            <div class="mt-3">
              <b-form-checkbox v-model="displayCompletedSites" switch @change="switchView()"
                >Include Completed Study Site
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="12">
            <p class="manageApplicationAccessText">
              To learn more about how study sites appear on your My Study-Sites list,
              <a href="/support/studies/site-not-listed">click here</a>
            </p>
            <!-- <p v-if="canSeeApplicationAccess" class="manageApplicationAccessText">
              To manage Application Access for a study not listed below,
              <router-link to="/custom-application-access">click here</router-link>
            </p> -->
          </b-col>
        </b-row>
      </div>
      <b-container id="tableSection" class="mt-2 mb-4">
        <b-table
          id="sites-table"
          ref="siteTable"
          :busy.sync="busy"
          :current-page="currentPage"
          :fields="studySitesFields()"
          :filter="filters.everywhere"
          :items="tableItems"
          :per-page="perPage"
          empty-text="There are no study-sites available right now."
          responsive
          show-empty
          table-class="cardTable text-center"
          tbody-tr-class="tBodyTrClass"
          tdClass="tdClassAlignCenter"
          thClass="thClass"
          thead-class="thCustomClass"
          @filtered="onFiltered"
          @row-clicked="viewSite"
        >
          <template #table-caption>
            <b-container v-if="totalRows > 0">
              <b-row>
                <b-col
                  ><p v-if="sites" style="font-size: 16px">
                    <strong>{{ totalRows }}</strong>
                    {{ totalRows > 1 && totalRows !== 0 ? 'studies' : 'study' }}
                  </p></b-col
                >
                <b-col>
                  <span>
                    <label for="perPageSelector">Per page:</label>
                    <b-dropdown
                      id="perPageSelector"
                      :text="perPage.toString()"
                      variant="outline-secondary"
                    >
                      <b-dropdown-item style="pointer-events: none; opacity: 0.6"
                        >-- Select an option: --
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-for="(item, idx) in perPageOptions"
                        :key="idx"
                        @click="perPage = item"
                        >{{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </b-col>
                <b-col>
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    align="center"
                    aria-controls="sites-table"
                    pills
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-container>
          </template>
          <template #table-busy>
            <div class="text-center text-secondary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #head()="data">
            <div class="text-nowrap">
              {{ data.label }}
            </div>
          </template>
          <template #cell(site)="row">
            <p class="studySiteText mb-0">
              {{ row.item.studyInfo['studyID'] }} - {{ row.item.siteInfo['siteNumber'] }}
            </p>
          </template>
          <template #cell(actions)="row">
            <b-button class="mr-2" variant="link" @click="viewSite(row.item)">
              <b-img :src="actionArrow"></b-img>
            </b-button>
          </template>
          <template #cell(details)="row">
            <b-button variant="link" @click="row['toggleDetails']">
              <b-img :src="row['detailsShowing'] ? arrowUpCircle : arrowDownCircle"></b-img>
            </b-button>
          </template>
          <template #cell(siteInfo.simplifySiteStatus)="row">
            <status :status="row.item['siteInfo']['simplifySiteStatus']" />
          </template>
          <template #cell(siteEnrollmentData.randomized)="row">
            <strong>{{ randomized(row.item) }}</strong>
          </template>
          <template #row-details="row">
            <site-table-details :row="row.item" />
          </template>
        </b-table>
      </b-container>
    </section>

    <div v-if="!visible && canAccessSite">
      <router-view :sites="responseStudySites" :user="user"></router-view>
    </div>
  </main>
</template>
<script>
  import actionArrow from '../../images/actionArrow.png';
  import arrowUpCircle from '../../images/arrowUpCircle.png';
  import arrowDownCircle from '../../images/arrowDownCircle.png';
  import tableFieldsMixin from './mixins/tableFieldsMixin';
  import SiteTableDetails from './common/SiteTableDetails';
  import Status from './common/Status';

  export default {
    name: 'my-study-sites',
    components: { Status, SiteTableDetails },
    mixins: [tableFieldsMixin],
    props: {
      user: Object,
    },
    metaInfo() {
      let metaTitle = this.$appName + 'My Study-Sites';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        responseStudySites: [],
        actionArrow: actionArrow,
        arrowUpCircle: arrowUpCircle,
        arrowDownCircle: arrowDownCircle,
        sites: [],
        tableItems: [],
        busy: false,
        perPage: 3,
        currentPage: 1,
        totalRows: 0,
        visible: false,
        filters: {
          everywhere: '',
        },
        perPageOptions: [3, 5, 10, 15, 20],
        displayCompletedSites: false,
        filteredSites: [],
        hasOversightPermission: false,
        canAccessSite: false,
      };
    },
    computed: {
      canSeeApplicationAccess() {
        return this.user.permissions.some(p => p.name === 'access application access');
      },
      // useSimAssociationsVersion() {
      //   if (Object.keys(this.$route.query).includes('useSimAssociationsVersion')) {
      //     return this.$route.query['useSimAssociationsVersion'] === 'true';
      //   }
      //   return window['Laravel']['feature_flags']['useSimAssociationsVersion'];
      // },
    },
    created() {
      this.hasOversightPermission = this.user.permissions.some(
        p => p.name === 'access enrollment oversight',
      );
      this.filters.everywhere = this.$route.query.study;
      this.setupHomepage();
    },
    watch: {
      $route() {
        this.visible = this.$route.name === 'studies';
        this.checkAccess();
      },
    },
    methods: {
      randomized(item) {
        let acceptedStatuses = ['ONGOING', 'ACTIVATED', 'COMPLETED'];
        if (
          Object.keys(item).length > 0 &&
          acceptedStatuses.includes(item['siteInfo']['simplifySiteStatus'].toUpperCase()) &&
          'siteEnrollmentData' in item
        ) {
          return item['siteEnrollmentData']['randomized'];
        } else {
          return 'N/A';
        }
      },
      setupHomepage() {
        this.visible = this.$route.name === 'studies';
        this.getSites();
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
        if (this.$route.query.study && this.totalRows === 1) {
          this.$router.replace({
            name: 'site-summary',
            params: {
              siteId: filteredItems[0]['siteInfo']['siteNumber'],
              studyId: filteredItems[0]['studyInfo']['studyID'],
            },
          });
        }
      },
      viewSite(selected) {
        this.$router.push({
          name: 'site-summary',
          params: {
            siteId: selected['siteInfo']['siteNumber'],
            studyId: selected['studyInfo']['studyID'],
          },
        });
      },
      async getSites() {
        try {
          this.busy = true;
          let url = `/api/get-site-enrollment`;
          let params = {
            module: 'My Studies',
            // use_sim_associations_version: this.useSimAssociationsVersion ? 1 : 0,
            grouped: 1,
          };
          let response = await axios.get(url, { params });
          if (response.status !== 204) {
            this.responseStudySites = _.cloneDeep(response.data['items']);
            this.sites = response.data['items']
              .filter(
                el =>
                  el['siteInfo']['siteNumber'] &&
                  el['studyInfo']['studyID'] &&
                  el['siteInfo']['simplifySiteStatus'],
              )
              .map(el => {
                return {
                  formsInfo: el['formsInfo'] || '',
                  siteEnrollmentData: {
                    randomized: el.siteEnrollmentData?.randomized || '',
                  },
                  siteInfo: {
                    investigatorName: el['siteInfo']['investigatorName'] || '',
                    simplifySiteStatus: el['siteInfo']['simplifySiteStatus'] || '',
                    siteNumber: el['siteInfo']['siteNumber'] || '',
                    countryName: el['siteInfo']['countryName'] || '',
                  },
                  studyInfo: {
                    developmentPhase: el['studyInfo']['developmentPhase'] || '',
                    studyID: el['studyInfo']['studyID'] || '',
                    therapeyticArea: el['studyInfo']['therapeyticArea'] || '',
                    title: el['studyInfo']['title'] || '',
                  },
                };
              })
              .filter(el => {
                return ['SELECTED', 'ONGOING', 'ACTIVATED', 'COMPLETED'].includes(
                  el['siteInfo']['simplifySiteStatus'].toUpperCase(),
                );
              })
              .sort((a, b) => {
                return a['studyInfo']['studyID'].localeCompare(b['studyInfo']['studyID']);
              });

            let countryNames = this.sites.map(site => site['siteInfo']['countryName']);
            let isSameCountry = countryNames.every((val, i, arr) => val === arr[0]);
            if (isSameCountry) {
              localStorage.setItem('countryName', countryNames[0]);
            }

            if (this.sites.length === 1 && this.visible) {
              this.redirectToSummary();
            }
            this.filterSites();
          }
          this.checkAccess();
        } catch (error) {
          console.error(error);
          alert(`Server is not responding, please try again later`);
        }
        this.busy = false;
      },
      redirectToSummary() {
        const validStatus = ['Ongoing', 'Planned', 'Completed', 'Proposed'].includes(
          this.sites[0]['siteInfo']['simplifySiteStatus'],
        );
        if (validStatus) {
          this.$router.replace({
            name: 'site-summary',
            params: {
              siteId: this.sites[0]['siteInfo']['siteNumber'],
              studyId: this.sites[0]['studyInfo']['studyID'],
            },
          });
        }
      },
      checkAccess() {
        if (!this.visible) {
          let studySite = this.sites.find(element => {
            return (
              element['siteInfo']['siteNumber'] === this.$route.params['siteId'] &&
              element['studyInfo']['studyID'] === this.$route.params['studyId']
            );
          });
          this.canAccessSite = studySite !== undefined && Object.keys(studySite).length > 0;
          if (!this.canAccessSite) {
            this.$router.replace({ name: 'studies' }).then(r => {
              this.$bvToast.toast(`Access denied`, {
                title: 'Error',
                autoHideDelay: 5000,
                appendToast: true,
                variant: 'danger',
              });
            });
          }
        }
      },
      filterSites() {
        let accepted = ['SELECTED', 'ONGOING', 'ACTIVATED'];
        this.filteredSites = this.sites.filter(element =>
          accepted.includes(element['siteInfo']['simplifySiteStatus'].toUpperCase()),
        );
        this.tableItems = this.filteredSites;
        this.totalRows = this.tableItems.length;
      },
      switchView() {
        this.tableItems = this.displayCompletedSites ? this.sites : this.filteredSites;
        this.totalRows = this.tableItems.length;
        this.currentPage = 1;
      },
      switchMode() {
        this.$emit('switch-mode', 'enrollment-oversight');
      },
    },
  };
</script>

<style>
  .tBodyTrClass {
    height: 108px;
    background: #ffffff;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
    border-radius: 24px;
    box-shadow: 0px -4px 4px -2px rgba(23, 38, 74, 0.08);
  }

  .tBodyTrClassMobile {
    background: #ffffff;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
    border-radius: 24px;
    box-shadow: 0px -4px 4px -2px rgba(23, 38, 74, 0.08);
  }

  .whiteBackground {
    background: #fffbfe;
  }

  .tdClassAlignCenter {
    text-align: center;
    vertical-align: middle;
  }

  .thClass {
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    /*letter-spacing: 0.25px;*/
    color: #1c1b1e;
  }

  .myStudiesHeader {
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }

  .filterRow .col {
    display: inline-block;
    vertical-align: middle;
    float: none;
  }

  #filterEverything {
    display: inline;
    width: 40%;
  }

  #sites-table .table th,
  .table td {
    vertical-align: middle;
  }

  .cardTable {
    border-collapse: separate;
    border-spacing: 0 10px;
  }

  #sites-table td {
    padding: 10px;
  }

  #sites-table th {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #383838;
  }

  #sites-table thead > tr:first-child:hover {
    background-color: transparent;
    cursor: default;
  }

  #sites-table tr:hover {
    background-color: #fbf5ff;
    cursor: pointer;
  }

  #sites-table td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  #sites-table td:last-child {
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
  }

  .thCustomClass {
    background-color: transparent;
    display: table-header-group;
    vertical-align: middle;
  }

  .studySiteText {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #00004e;
  }

  .countryCityText {
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }

  .manageApplicationAccessText {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #383838;
  }

  .multiselect__input,
  .multiselect__single {
    background: #f4eff4;
  }

  .multiselect__tags {
    background: #f4eff4;
    border-radius: 24px;
  }
</style>
